module.exports = __webpack_public_path__ + "public/img/tuo.c22d67ba.png";